// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__2Q9Ue","container":"styles_container__2tmhz","titleText":"styles_titleText__16MdJ","buttonSubscribe":"styles_buttonSubscribe__1C1fa"};